import { action, observable } from "mobx";
import { SharedValues } from "../Tools/SharedValues";
import RequestsProcessor from "../Tools/RequestsProcessor";
import { IApiResponse } from "../../Interfaces/Entity/ApiResponse";

export interface INumberDict {
  [key: string]: number;
}

export interface IStringDict {
  [key: string]: string;
}

export type TStateKeys = "Active" | "Deactivated" | "Removed";
export type TState = { [K in TStateKeys]: number };

export interface ISharedValues {
  language: string;
  localization: INumberDict;
  version: string;
  notificationTypes: INumberDict;
  states: TState;
  allowedHtmlTags: string[];
  dataReadAndRedirectAttribute: string;
  userManagementUrl: string;
}

export interface ISharedValuesStore {
  language: string;
  localization: INumberDict;
  version: string;
  notificationTypes: INumberDict;
  states: TState;
  allowedHtmlTags: string[];
  dataReadAndRedirectAttribute: string;
  isSessionValid: boolean;

  getValues: () => Promise<ISharedValues>;
  signOut: () => Promise<void>;
  triggerTokenRefresh: () => Promise<void>;
}

export class SharedValuesStore implements ISharedValuesStore {
  @observable language: string = "";
  @observable localization: INumberDict;
  @observable version: string = "";
  @observable notificationTypes: INumberDict;
  @observable states: TState;
  @observable allowedHtmlTags: string[];
  @observable dataReadAndRedirectAttribute: string;
  @observable userManagementUrl: string;
  @observable isSessionValid: boolean = true;

  requestsProcessor: RequestsProcessor;

  @action.bound
  init() {
    this.requestsProcessor = new RequestsProcessor();
  }

  @action.bound
  async signOut() {
    try {
      await this.requestsProcessor.get("Authentication/SignOut", "SignOut");
    } catch (error) {
      console.error(error);
    }
  }

  @action.bound
  async triggerTokenRefresh() {
    try {
      await this.requestsProcessor.get<any>("Authentication/TokenRefresh", "TokenRefresh");
    } catch (error) {
      console.error(error.response);
    }
  }

  @action.bound
  async getValues() {
      try {
          const response: IApiResponse<ISharedValues> = await this.requestsProcessor.get<IApiResponse<ISharedValues>>(
        "values/shared",
        "GetSharedValues"
          );
      const responseData: ISharedValues = response.data;

      this.language = responseData.language;
      this.localization = (responseData.localization as unknown) as INumberDict;
      SharedValues.localization = responseData.localization;
      this.version = responseData.version;
      this.notificationTypes = (responseData.notificationTypes as unknown) as INumberDict;
      this.states = (responseData.states as unknown) as TState;
      this.allowedHtmlTags = responseData.allowedHtmlTags;
      this.dataReadAndRedirectAttribute = responseData.dataReadAndRedirectAttribute;
      this.userManagementUrl = responseData.userManagementUrl;
      return responseData;
    } catch (error) {
      console.error(error);
    }
  }
}
